import FeatureItem from './FeatureItem'
import { Row, Col, Container, Button } from 'react-bootstrap'
import Link from 'next/link'
import { Trans } from 'react-i18next';

const Feature = (props) => {
  const { t, query } = props
  return (
    <>
      <div className='container-feature-flirt'>
        <Container>
          <Row>
            <Col lg={1} xs={1} md={1}></Col>
            <Col lg={10} xs={10} md={10}>
              <h3 className='container-feature-flirt__title'>
                {t('feature.h3-1')} <span style={{ color: '#ec0043' }} >{t('feature.h3-2')}</span>?
            </h3>
            </Col>
            <Col lg={1} xs={1} md={1}></Col>
          </Row>
          <div className='container-feature-flirt__line'></div>
          <Row>
            <Col lg={2} xs={1} md={1}></Col>
            <Col lg={8} xs={10} md={10}>
              <div className='container-feature-flirt__description'>
                <p>
                  {t('feature.p-1')}
                  <span style={{ color: '#c70038' }}>{t('feature.p-2')}</span>
                  {t('feature.p-3')}
                </p>
              </div>
            </Col>
            <Col lg={2} xs={1} md={1}></Col>
          </Row>
          <FeatureItem t={t} />
        </Container>
      </div>
      <Container className='text-center'>
        <h3 className='container-feature-flirt__title' style={{ fontSize: '36px', fontWeight: 900, fontFamily: 'Barlow, sans-serif', marginTop: '30px' }}>
          <Trans i18nKey="Join our <1>global</1> community" t={t}>
            Join our <span style={{ color: '#ec0043' }}>global</span> community
          </Trans>
        </h3>
        <div style={{ background: '#f84f7f', width: '150px', height: '2px', margin: '30px auto' }}></div>
        <Row>
          <Col lg={1} xs={1} md={1}></Col>
          <Col lg={10} xs={10} md={10} style={{  paddingBottom: '50px' }}>
            <div className='container-footer__top'>
              <p>
                <Trans i18nKey="footer.description-1" t={t}>
                  Looking to connect with people worldwide? Flirtbees offers clear guidelines and a huge pool of potential matches. We've got <span style={{ color: '#ec0043' }}>1+ million users from 100+ countries</span>, and that number keeps growing. We're accessible globally, and we even have amazing features like automatic translation built-in, which makes talking to people from different countries a lot easier. Basically, meeting someone from another part of the world is simpler than ever. If you're interested in connecting with a truly global community, and finding those connections through a platform like Flirtbees, we'd love for you to join us.
                </Trans>
                  <br/> <span style={{ color: '#ec0043' }}>{t('footer.description-2')}</span> {t('footer.description-3')} {t('footer.description-4')}
              </p>
              <Link href={{ pathname: '/trial', query: query, shallow: true }}>
                <a className='button__free-trial btn btn-primary mt-3'>
                  {t('free-trial')}
                </a>
              </Link>
              <div>
                <img
                  src='/images/map.jpg'
                  style={{ maxHeight: '500px', maxWidth: '100%' }}
                />
              </div>
            </div>
          </Col>
          <Col lg={1} xs={1} md={1}></Col>
        </Row>
      </Container>
    </>
  )
}

export const getServerSideProps = async ({ locale, query }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale , ['common', 'landingpage', 'questions'], nextI18NextConfig)),
      query: query
    },
  }
}

export default Feature
